import Loader from '@/components/ui/Loader';
import {
  useGetAgencyWebsiteFromEstimateId,
  useGetEstimateFromSharedLink,
} from '@/hooks/useEstimate';
import { NavLink, useLocation, useParams } from 'react-router';
import { EstimateDetails } from '../distributor/clients/estimates/ViewEstimatePage';
import StyledContainer from '@/components/styled/StyledContainer';
import { useTranslation } from '@/i18n';
import { useLanguage } from '@/contexts/LanguageContext';
import { useEffect } from 'react';
import { SupportedLocale } from '@/types/supported-locale.type';

const ViewProtectedEstimatePage = () => {
  const { projectId = '', estimateId = '' } = useParams();
  const location = useLocation();
  const { t } = useTranslation();

  const accessToken =
    new URLSearchParams(location.search).get('accessToken') ?? '';

  const {
    data: estimateResponse,
    isLoading,
    isSuccess,
    isError,
  } = useGetEstimateFromSharedLink({
    estimateId,
    projectId,
    accessToken,
  });

  const { data: agencyWebsiteResponse } =
    useGetAgencyWebsiteFromEstimateId(estimateId);

  const { changeLanguage, currentLanguage } = useLanguage();

  useEffect(() => {
    const estimateLanguage = isSuccess
      ? ((estimateResponse?.language?.toLowerCase() as SupportedLocale) ??
        undefined)
      : undefined;
    if (!!estimateLanguage && estimateLanguage !== currentLanguage) {
      changeLanguage(estimateLanguage);
    }
  }, [
    changeLanguage,
    currentLanguage,
    isSuccess,
    estimateResponse?.language,
    estimateResponse,
  ]);

  if (isLoading) return <Loader />;
  if (isError) {
    return (
      <StyledContainer>
        <div className="p-8">
          <p>{t('common.linkExpired')}</p>
          {agencyWebsiteResponse && agencyWebsiteResponse.website && (
            <NavLink
              to={agencyWebsiteResponse.website}
              className="bg-brand-50 rounded-md text-brand-600"
            >
              {t('common.goToHomepage')}
            </NavLink>
          )}
        </div>
      </StyledContainer>
    );
  }

  return (
    isSuccess && (
      <EstimateDetails
        estimateResponse={estimateResponse}
        projectId={projectId}
        accessToken={accessToken}
        shouldHideInternationalFlights
        key={estimateResponse.id}
      />
    )
  );
};

export default ViewProtectedEstimatePage;
